export const HOME = "/";
export const SIGN_UP_ROLE = "/sign-up-role";
export const CONTACT = "/contact";
export const ACCOUNT = "/account";
export const ABOUT = "/about";
export const PRODUCT_DETAILS = "/product-details/:id";
export const SIGN_UP = "/sign-up";
export const VENDOR_SIGN_UP = "/vendor-sign-up";
export const LOGIN = "/login";
export const WISH_LIST = "/wish-list";
export const ADMIN_HOME = "/admin";
export const CART_PAGE = "/cart";
export const SERVICES = "services";
export const CHECKOUT = "/checkout";
export const CONFIRM_ORDER = "/orderPlaced";
export const ADMIN_PRODUCT = "/products";
export const ADMIN_SERVICES = "/admin-services";
export const ADMIN_ORDERS = "/admin-orders";
export const ADMIN_CARTS = "/admin-carts";
export const ADMIN_BANNERS = "/admin-banners";
export const ADMIN_ADS = "/admin-ads";
export const ADMIN_SUBSCRIPTIONS = "/admin-subscriptions";
export const ADMIN_PLANS = "/admin-plans";
export const ADMIN_LOCATIONS = "/admin-locations";
export const ADMIN_DELIVERY_FEES = "/admin-delivery-fees";
export const ADMIN_SERVICE_FEES = "/admin-service-fees";
export const ADMIN_VIDEO_ADS = "/admin-video-ads";
export const ADMIN_PAYOUTS = "/admin-payouts";
export const ADMIN_PAYMENTS = "/admin-payments";
export const ADMIN_REFUNDS = "/admin-refunds";
export const ADMIN_COUPONS = "/admin-coupons";
export const USERS = "/users";
export const CATEGORIES = "/categories";
export const CLIENT_CATEGORY_DETAILS = "/client-category/:id";
export const VENDORS = "/vendors";
export const BOOKINGS = "/bookings";
export const PROFILE = "/profile";
// NOTE: ONLY USE THIS IN PRODUCTION, CHANGE THE URLS TO YOUR LOCALHOST IN DEVELOPMENT
export const BACKEND_BASE_URL = "https://api.birthnon.com/api-v1/";
export const BASE_URL = "https://api.birthnon.com";
// NOTE: YOU MAY CHANGE THE URLS HERE TO YOUR LOCALHOST
// export const BACKEND_BASE_URL = "http://192.168.0.100:8000/api-v1/";
// export const BASE_URL = "http://192.168.0.100:8000";
export const LOGIN_BG =
  "https://plus.unsplash.com/premium_photo-1728224403721-a4affa8e30ff?q=80&w=1932&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D";
export const SETTINGS = "/settings";
export const VERIFY_OTP = "/verify-otp";
